// extracted by mini-css-extract-plugin
module.exports = {"grid-button":"style_grid-button__20g8G","danger":"style_danger__2aY5q","icon-wrapper":"style_icon-wrapper__2VQJD"};